import { NgModule } from '@angular/core'
import { WatchRoutingModule } from './watch-routing.module'
import { WatchComponent } from './components/watch.component'
import { WatchAnalyticsService } from './services/watch-analytics.service'
import { WatchDataService } from './services/watch-data.service'
import { CommonModule } from '@angular/common'
import { WatchCarouselModule } from '../libs/watch-carousel/watch-carousel.module'
import { LargeEventCardModule } from '../libs/large-event-card/large-event-card.module'
import { ContentCardModule } from '../libs/content-card/content-card.module'
import { ElementIsVisibleModule } from '../libs/element-is-visible/element-is-visible.module'
import { LazyLoadModule } from '../../../projects/lazy-load/src/lib/lazy-load.module'
import { AnalyticsModule } from '../shared/analytics/analytics.module'
import { AvatarCardModule } from '../libs/avatar-card/avatar-card.module'
import { SkeletonModule } from '../libs/skeletons/skeleton/skeleton.module'
import { SvgModule } from '../shared/svg/svg.module'
import { PersonalizationCtaModule } from '../libs/personalization-cta/personalization-cta.module'
import { MapPipeModule } from '../libs/map-pipe/map-pipe.module'

@NgModule({
  imports: [
    WatchRoutingModule,
    CommonModule,
    WatchCarouselModule,
    LargeEventCardModule,
    ContentCardModule,
    ElementIsVisibleModule,
    LazyLoadModule,
    AvatarCardModule,
    AnalyticsModule,
    SvgModule,
    SkeletonModule,
    PersonalizationCtaModule,
    MapPipeModule
  ],
  declarations: [WatchComponent],
  exports: [WatchComponent],
  providers: [WatchDataService, WatchAnalyticsService]
})
export class WatchModule {}
